import { useState } from 'react';
import Helmet from 'react-helmet';

import Formsy from 'formsy-react';
import { LoaderCircle } from 'lucide-react';
import moment from 'moment-timezone';
import { Row, Col, Button, Label, FormGroup, SheetBody, DefaultSheet, InputNumberFormat, Input, DatePickerPreset, SheetFooter } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import { useParams } from '@Components/RouterProvider';
import history from 'utils/history';

import { useAllocationStore } from '../store';

export default function FormCostUpdater() {
  const { collection: { item, useLoad, reset }, loading, propagatePayout } = useAllocationStore()
  const { handleSuccess } = useAppAlert()
  const { id } = useParams()

  const [payoutToUpdate, setPayoutToUpdate] = useState(0)
  const [baseDate, setBaseDate] = useState(moment())

  const loadData = useLoad(id)

  const handleClickSidebarClose = () => {
    history.push('/offer/allocations');
    reset()
  }

  const handleSubmit = async model => {
    try {
      model = Object.assign(model, { payoutToUpdate, baseDate })
      model.baseDate = model.baseDate.format('YYYY-MM-DD')

      const data = await propagatePayout(model)

      if (data > 0) {
        handleSuccess("Success", `${data} records were found and it will be updated`)
      } else {
        handleSuccess("Not found", `No records were found`)
      }
      await loadData()
    } catch {
      handleSuccess("Not found", `No records were found`)
    }
  }

  if (!item) return null

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClickSidebarClose() }}
    title='Payout Updater'
  >
    <Helmet title="Payout Updater" />
    <Formsy onValidSubmit={handleSubmit}>
      <SheetBody>
        <Row>
          <Col size='6'>
            <Label>Allocation ID</Label>
            <Input readOnly name="allocation_id" value={item.id} />
          </Col>
          <Col size='6'>
            <Label>Publisher</Label>
            <Input readOnly name="publisher_id" value={item.publisher.id} />
          </Col>
          <Col size='6'>
            <Label>Payout Type</Label>
            <Input readOnly name="payouttype" value={item.payouttype} />
          </Col>
          <Col size='6'>
            <Label>Current Payout</Label>
            <InputNumberFormat value={item.payout} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$ '} decimalScale={2} fixedDecimalScale={true} />
          </Col>
          <Col size='6'>
            <FormGroup>
              <Label>New payout</Label>
              <InputNumberFormat
                name="payout"
                value={payoutToUpdate}
                onValueChange={({ floatValue }) => setPayoutToUpdate(floatValue)}
                thousandSeparator=","
                decimalSeparator="."
                prefix={'$ '}
                decimalScale={2}
                fixedDecimalScale={true}
                className="form-control" />
            </FormGroup>
          </Col>
          <Col size='6'>
            <FormGroup>
              <Label>Date</Label>
              <DatePickerPreset
                showHoursSelector={false}
                mode='single'
                value={baseDate}
                onChange={date => setBaseDate(date)}
                preset={false}
                numberOfMonths={1}
                mask="YYYY/MM/DD"
                valueType='moment'
              />
            </FormGroup>
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button variant='ghost' onClick={handleClickSidebarClose}>Cancel</Button>
        <Button color='accent' type="submit" disabled={loading}>
          {loading ? <LoaderCircle className='animate-spin' size={16} /> : "Update"}
        </Button>
      </SheetFooter>
    </Formsy>
  </DefaultSheet >
}

FormCostUpdater.propTypes = {}
